import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiEventManager } from 'ng-jhipster';

import { ICargoGroupMySuffix } from 'src/app/shared/model/cargo-group-my-suffix.model';
import { CargoGroupMySuffixService } from './cargo-group-my-suffix.service';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';

import { ConfirmationModelService } from 'src/app/shared/confirmation-modal/confirmation-model.service';
import { FutureDataType } from 'src/app/shared/model/future_data_type.model';

@Component({
    selector: 'jhi-cargo-group-my-suffix-delete-dialog',
    templateUrl: './cargo-group-my-suffix-delete-dialog.component.html'
})
export class CargoGroupMySuffixDeleteDialogComponent {
    cargoGroup: ICargoGroupMySuffix;
    futureStatus: boolean = false;
    isConfirmed: boolean = false;

    constructor(
        private cargoGroupService: CargoGroupMySuffixService,
        public activeModal: NgbActiveModal,
        private eventManager: JhiEventManager,
        private futureRecordService: ConfirmationModelService,
        private languageChangeService: LanguageChangeService,
        private activatedRoute: ActivatedRoute
    ) {
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }
    
    setFutureStatus(futureStatus) {
        this.futureStatus = futureStatus;
    }

    confirmDelete(id: number) {
        this.isConfirmed = true;
        if (this.futureStatus) {
            this.updateExistedFutureRecordStatus(id);
        }
        this.cargoGroupService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'cargoGroupListModification',
                content: 'Deleted an cargoGroup'
            });
            this.activeModal.dismiss(true);
        });
    }

    updateExistedFutureRecordStatus(id: number) {
        this.futureRecordService.updateExistedFutureRecordStatus({
            masterId: this.cargoGroup.id,
            futureDataType: FutureDataType.CARGO_GROUP.valueOf(),
            fromEffectiveDateFormatted: this.cargoGroup.fromEffectiveDate,
            masterStatus : this.cargoGroup.activeStatus == 'ACTIVE' ? 'IN_ACTIVE' : 'ACTIVE',
        }).subscribe(response => {
            console.log(response.body);
        });
    }
}

@Component({
    selector: 'jhi-cargo-group-my-suffix-delete-popup',
    template: ''
})
export class CargoGroupMySuffixDeletePopupComponent implements OnInit, OnDestroy {
    private ngbModalRef: NgbModalRef;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private modalService: NgbModal,
        private languageChangeService: LanguageChangeService
    ) {
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
    }

    ngOnInit() {
        this.activatedRoute.data.subscribe(({ cargoGroup }) => {
            console.log('cargoGroup ', cargoGroup);
            setTimeout(() => {
                this.ngbModalRef = this.modalService.open(CargoGroupMySuffixDeleteDialogComponent as Component, {
                    size: 'lg',
                    backdrop: 'static'
                });
                this.ngbModalRef.componentInstance.cargoGroup = cargoGroup;
                this.ngbModalRef.result.then(
                    result => {
                        //this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => this.router.navigate(['/data-management/cargo-group']));
                        this.ngbModalRef = null;
                    },
                    reason => { 
                        //this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => this.router.navigate(['/data-management/cargo-group']));
                        this.ngbModalRef = null;
                    }
                );
            }, 0);
        });
        
        // this.languageChangeService.currentLanguage.subscribe(language => {
        //     console.log(language);
        // });
    }

    ngOnDestroy() {
        this.ngbModalRef = null;
    }
}
